export function shouldShowAppBootSkeleton() {
    // Authentication is resolved by the router. Keep the current route visible
    // while that request completes so reloads refresh data in place instead of
    // replacing the application with a full-page skeleton.
    return false;
}
